var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0005 5.02721C14.8632 4.99855 16.6646 5.69251 18.0267 6.96346L21.6955 3.37596C19.3417 1.17039 16.2259 -0.0390273 13.0005 0.000960935C10.5905 0.000404079 8.22797 0.670256 6.17696 1.93561C4.12596 3.20096 2.46738 5.01192 1.38672 7.16596L5.59047 10.4297C6.10448 8.86678 7.09614 7.50463 8.42559 6.53535C9.75505 5.56607 11.3552 5.03856 13.0005 5.02721Z",
    fill: "#E43E2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4801 13.2901C25.4954 12.3964 25.4031 11.5042 25.2051 10.6326H13.0001V15.4576H20.1651C20.0292 16.3035 19.7236 17.1132 19.2667 17.838C18.8098 18.5628 18.211 19.1877 17.5063 19.6751L21.6088 22.8526C22.8874 21.6182 23.8929 20.1293 24.5603 18.4822C25.2278 16.8351 25.5424 15.0663 25.4838 13.2901H25.4801Z",
    fill: "#3B7DED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60543 15.5716C5.3212 14.744 5.17467 13.8754 5.17168 13.0003C5.17686 12.1267 5.31814 11.2592 5.59043 10.4291L1.38668 7.16534C0.47492 8.97552 0 10.9741 0 13.001C0 15.0278 0.47492 17.0264 1.38668 18.8366L5.60543 15.5716Z",
    fill: "#F0B501"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0004 26.0008C16.167 26.0903 19.2476 24.9635 21.6092 22.852L17.5067 19.6745C16.1765 20.5663 14.6012 21.0207 13.0004 20.9745C11.3566 20.9647 9.75756 20.4376 8.43019 19.4679C7.10281 18.4982 6.11449 17.1351 5.60542 15.572L1.40167 18.837C2.47942 20.9901 4.13528 22.8006 6.18382 24.0659C8.23235 25.3311 10.5927 26.0011 13.0004 26.0008Z",
    fill: "#2BA24C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.695e4a62de659b59a59be53b9229ce05.svg";
export { ForwardRef as ReactComponent };